import { useState } from 'react'
import { thumbUrl } from './money'

interface Props {
  name: string
  imageUrl: string | null
  /** Sizing and rounding come from the caller: a tile, a row and a form differ. */
  className?: string
  /** The full picture instead of the thumbnail. */
  full?: boolean
}

/** A product's picture, or its initial on a neutral tile when it has none. */
export function ProductImage({ name, imageUrl, className = '', full = false }: Props) {
  const [failed, setFailed] = useState(false)

  if (imageUrl && !failed) {
    return (
      <img
        src={full ? imageUrl : thumbUrl(imageUrl)}
        alt={name}
        loading="lazy"
        className={`object-cover ${className}`}
        onError={() => setFailed(true)}
      />
    )
  }

  return (
    <div
      aria-hidden="true"
      className={`flex items-center justify-center bg-default-100 text-2xl font-semibold text-foreground/30 ${className}`}
    >
      {name.trim().charAt(0).toUpperCase()}
    </div>
  )
}
